import { SET_WORKSPACE, UPDATE_CONFIGSTATUS } from "../actions/types";

const initialState = {
  workspace: { Workspace_id: -1, Name: "" },
};

//Handling User
export const workspaceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_WORKSPACE:
      return {
        ...state,
        ...payload,
      };
    case UPDATE_CONFIGSTATUS:
      return {
        ...state,
        workspace: {
          ...state.workspace,
          ...{
            ...state.workspace.workspace,
            ModelingStatus: payload,
          },
        },
      };
    default:
      return state;
  }
};
